'use client';

import { Icon, Typography } from '@/app/common';
import { cn } from '@/app/lib';
import { CustomPortableText } from '@workspace/ui/PortableText';
import { Accordion } from '@workspace/ui/common';
import { FAQListProps } from '../interfaces';

type FAQAccordionItem = FAQListProps['items'][number] & { id: string };

export function FAQList({ items }: FAQListProps) {
  const accordionItems: FAQAccordionItem[] =
    items?.map((item, index) => ({
      ...item,
      id: `${item.question}-${index}`,
    })) ?? [];

  return (
    <Accordion
      items={accordionItems}
      selectionMode="multiple"
      className="flex flex-col"
      itemSpacingClassName="space-y-0"
      renderItemRow={(item, isExpanded, onToggle) => (
        <div>
          <div
            className={cn(
              'flex justify-between items-center border-b border-secondary-200 bg-secondary-50/33 p-sm',
              '[&>*]:transition-all [&>*]:duration-300 [&>*]:ease-in cursor-pointer',
              isExpanded && 'border-primary text-primary bg-accent',
            )}
            onClick={onToggle}
          >
            <Typography variant="bodyMd" className={cn('font-semibold', isExpanded && 'text-primary font-bold!')}>
              {item.question}
            </Typography>
            <Icon
              name="ChevronDown"
              className={cn('flex-shrink-0', isExpanded && 'rotate-180 text-primary')}
              size={24}
            />
          </div>
        </div>
      )}
      renderItemContent={(item, isExpanded, getHeight, contentRef) => (
        <div
          className={cn(
            'overflow-hidden transition-[height,opacity] duration-300 ease-in-out',
            isExpanded ? 'opacity-100' : 'opacity-0',
          )}
          style={{ height: isExpanded ? getHeight(item.id) : 0 }}
        >
          <div ref={contentRef} className="p-sm pb-lg">
            <CustomPortableText value={item.answer} />
          </div>
        </div>
      )}
    />
  );
}
